import React from 'react';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Hero } from './components/Hero';
import { InitialTestimonials, MoreTestimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { PackContents, MethodOverview } from './components/MethodOverview';
import { FAQ } from './components/FAQ';
import { CostComparison } from './components/CostComparison';
import { Guarantee, Footer } from './components/Footer';
import { FloatingNotification } from './components/FloatingNotification';
import { EmotionalClose } from './components/EmotionalClose';
const TransitionPhrase = () => <div className="max-w-3xl mx-auto px-6 py-12 md:py-20 text-center pt-[4px] pb-[4px]" data-id="element-0" data-mp="31c9uk2rwyxqx">
    <p className="text-xl md:text-3xl font-display italic text-brand-purpleDark/85 leading-relaxed font-[800]" data-id="element-1" data-mp="2wj8f9tnsow6t">
      La próxima sesión puede ser diferente.
    </p>
  </div>;
export function App() {
  return <div className="min-h-screen text-brand-text font-sans selection:bg-brand-purple/25 selection:text-brand-purpleDark bg-brand-surface" data-id="element-2" data-mp="23ut97wmn5o7m">
      <UrgencyBanner data-id="element-3" data-mp="3mlj6io8cn0zw" />
      <Hero data-id="element-4" data-mp="3mkrefndynled" />
      <PackContents data-id="element-5" data-mp="3mkhou0wtvg97" />
      <InitialTestimonials data-id="element-6" data-mp="3mjq1tehaqquj" />
      <PainPoints data-id="element-7" data-mp="3rc9f0ac2njyt" />
      <MethodOverview data-id="element-8" data-mp="3rbra6pbcfxfa" />
      <MoreTestimonials data-id="element-9" data-mp="3rdarmj8qkein" />
      <Guarantee data-id="element-10" data-mp="3rd19tixuhdo1" />
      <FAQ data-id="element-11" data-mp="3relvej26lm9r" />
      <CostComparison data-id="element-12" data-mp="5yh2n2cyzbp" />
      <TransitionPhrase data-id="element-13" data-mp="67yvnd9206b" />
      <EmotionalClose data-id="element-14" data-mp="5gez9t0lqvv" />
      <Footer data-id="element-15" data-mp="82jt1oitsae" />
      <FloatingNotification data-id="element-16" data-mp="2zl3alhpbj03q" />
    </div>;
}